module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/stations/station-type-trans/station-type-trans.component.css
// module id = ./src/app/stations/station-type-trans/station-type-trans.component.css
// module chunks = main